import { Component, Inject, Optional, AfterViewInit, OnInit, ChangeDetectorRef, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LearnMoreData } from 'src/app/common/models/learnMoreData';
import { DomainService } from 'src/app/common/services/domain.service';

@Component({
    selector: 'app-dialog-learn-more',
    templateUrl: './dialog-learn-more.component.html',
    styleUrls: ['./dialog-learn-more.component.css'],
    standalone: false
})
export class DialogLearnMoreComponent implements OnInit, AfterViewInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: LearnMoreData,
  @Optional() public dialogRef: MatDialogRef<DialogLearnMoreComponent>,
  private readonly domainService: DomainService, private readonly cdr: ChangeDetectorRef, private readonly destroyRef: DestroyRef) {}

  domainStatement = '';

  private readonly legacyDomains = [
    'Legal Practice', 'Continuous Improvement', 'Cultural Competence, Equity, Diversity and Inclusion',
    'Lawyer-Client Relationships', 'Practice Management', 'Professional Conduct',
    'Professional Contributions', 'Truth and Reconciliation', 'Well-being'
  ];

  ngOnInit(): void {
    if (!this.data?.comp_name || this.legacyDomains.includes(this.data.comp_name)) {
      return;
    }
    this.domainService.getDomains().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: domains => {
        const description = domains.find(domain => domain.Name?.trim().toLowerCase() === this.data.comp_name.trim().toLowerCase())?.Description?.trim();
        this.domainStatement = description || 'A domain statement is not available. You can still select the competencies listed for this domain.';
        this.cdr.markForCheck();
      },
      error: () => {
        this.domainStatement = 'Domain details are temporarily unavailable. You can still select the competencies listed for this domain.';
        this.cdr.markForCheck();
      }
    });
  }

  //This mapping can be converted to Ids once the competency templates are referenced by Ids in the database.
  rowMap = {"Foster collegiality and civility in the legal profession": 1,
    "Enhance the administration of justice": 2,
    "Advance access to legal services and access to justice": 3,
    "Critically evaluate a matter": 1,
    "Communicate effectively":2,
    "Advance client interests":3,
    "Commit to continuous improvement in the provision of services": 1,
    "Cultivate a growth mindset":2,
    "Build intelligence related to cultural competence, equity diversity and inclusion":1,
    "Incorporate equity, diversity and inclusion in practice":2,
    "Champion enumerated groups in professional activities":3,
    "Determine suitability of lawyer-client relationships": 1,
    "Establish lawyer-client relationships":2,
    "Engage in ongoing communication with clients":3,
    "Foster collaborative and trusting lawyer-client relationships":4,
    "Use effective time management and organization skills":1,
    "Manage files effectively and securely":2,
    "Use effective accounting and billing procedures":3,
    "Supervise and manage effectively":4,
    "Assess and manage practice risks":5,
    "Demonstrate technological competence":6,
    "Act ethically":1,
    "Demonstrate good character":2,
    "Use sound judgement":3,
    "Strengthen understanding of the truth regarding the experience of Indigenous Peoples in Alberta and Canada":1,
    "Demonstrate support for reconciliation with the Indigenous Peoples of Canada":2,
    "Build resilience":1,
    "Maintain personal health":2,
    "Demonstrate self-awareness":3,
    "Support well-being of others":4,
  };

  ngAfterViewInit() {
    this.hightlightRow();
  }

  access_to_legal_services = 'While access to justice is a commonly used phrase, it applies primarily to access to the court system. Access to legal services includes access to all types of services a lawyer might provide, some of which do not involve the courts. Access refers to more than affordability; it includes considerations relating to geographic location, language, and health, among others.';
  business_continuity_planning = 'The process of creating systems of prevention and recovery to deal with potential threats to a company. In addition to prevention, the goal is to enable ongoing operations before and during execution of disaster recovery.';
  enumerated_groups = 'Groups of people who share identities based on the characteristics set out in the Alberta Human Rights Act, which states that all persons are equal in: dignity, rights and responsibilities without regard to race, religious beliefs, colour, gender, gender identity, gender expression, physical disability, mental disability, age, ancestry, place of origin, marital status, source of income, family status or sexual orientation.';
  growth_mindset = 'The belief that one’s talents can be developed through hard work, good strategies, and input from others. Individuals who adopt more of a growth mindset are more likely to embrace lifelong learning, put in more effort to learn, view feedback as an opportunity to learn, believe failures are just temporary setbacks, willingly embrace challenges and view others’ success as a source of inspiration.'
  healthy_coping_skills = 'Constructive or positive ways we manage internal and external stress, and which are associated with good mental health. Some examples may include seeking out social support, establishing boundaries, practising gratitude, engaging in a hobby, getting enough sleep, exercising, spending time outdoors and journaling.';
  practice_risks = 'Threats that impact a lawyer’s reputation, opportunity, operating costs or ability to carry on business. Examples of risks in legal practice may include but are not limited to ethical complaints, insurance claims, cyber-attacks, fraud, theft, staffing issues, unexpected life events and disasters.';
  resilience = 'The process of adapting well in the face of adversity, trauma, tragedy, threats, or significant sources of stress, such as family and relationship problems, serious health problems, or workplace and financial stressors.';

  hightlightRow(){
    setTimeout(() => {
      const table = document.getElementsByClassName('indicator')[0];
      const rows = table?.getElementsByTagName('tr');

      if(rows && this.data?.comp && rows[this.rowMap[this.data.comp]]){
        rows[this.rowMap[this.data.comp]].classList.add('hightlighted-row');
        rows[this.rowMap[this.data.comp]].scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    }, 500);
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
